import { PropsWithChildren } from 'react';
import { Breakpoint } from 'src/utils/theme';
import * as S from './styles';

type Props = PropsWithChildren<{
  breakpoint: Breakpoint;
  reverse?: true;
}>;

export const DisplayNone = ({ breakpoint, reverse, children }: Props) => (
  <S.DisplayNone $breakpoint={breakpoint} $reverse={reverse}>
    {children}
  </S.DisplayNone>
);
